export function removeEmpty(obj: Record<string, unknown>) {
  return Object.fromEntries(Object.entries(obj).filter(([, v]) => v));
}

export function isEmpty(data: unknown) {
  return data == null;
}
